import useComponentSize from '@rehooks/component-size';
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { getThrottledWidthAndHeight } from './dynamicImageHelpers';

const StyledDynamicRspImageBg = styled.div`
	position: relative;
	background-image: url(${({ image }) => image});

	background-size: cover;
	transition: background-image 300ms linear;
	overflow: hidden;

	${({ center }) =>
		center &&
		css`
			background-position: 50% 50%;
		`}

	${({ placeholder, hidePlaceholder }) =>
		!hidePlaceholder &&
		css`
			&:after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-image: url(${placeholder});
				background-size: cover;
				z-index: -1;
				filter: blur(10px);

				${({ center }) =>
					center &&
					css`
						background-position: 50% 50%;
					`}
			}
		`}
`;

const DynamicRspImage = ({ image, hidePlaceholder, useCrop = true, ...props }) => {
	const elem = useRef(null);
	const size = useComponentSize(elem);
	const placeholder = `${image}&width=20&height=20`;
	// Edge browser has a weird bug with displaying the placeholder
	const isEdge = window.navigator.userAgent.indexOf('Edge/') > -1;
	const v = getThrottledWidthAndHeight(size.width, size.height);
	let current = size.width !== 0 ? `${image}&width=${v.width}&height=${v.height}` : '';

	if (!useCrop) {
		current = current.replace('crop', 'min');
	}

	const center = placeholder.indexOf('center=') === -1;

	return (
		<StyledDynamicRspImageBg
			{...props}
			ref={elem}
			image={current}
			hidePlaceholder={hidePlaceholder || isEdge}
			placeholder={placeholder}
			center={center}
		/>
	);
};

export default DynamicRspImage;
